import React from "react";
import "./footer.css";
import { BsLinkedin } from "react-icons/bs";
import { FiInstagram } from "react-icons/fi";
import { FaGithub } from "react-icons/fa";
import ResumePDF from "../../assets/Resume.pdf";

const Footer = () => {
    return (
        <footer>
            <a href="#" className="footer__logo">
                HARSHIT'S PORTFOLIO
            </a>
            <ul className="permalinks">
                <li>
                    <a href="#">Home</a>
                </li>
                <li>
                    <a href="#about">About</a>
                </li>
                <li>
                    <a href="#experience">Experience</a>
                </li>
                <li>
                    <a href="#projects">Projects</a>
                </li>
                <li>
                    <a href="#skills">Skills</a>
                </li>
                <li>
                    <a href={ResumePDF} target="_blank" rel="noopener noreferrer">Resume</a>
                </li>
                <li>
                    <a href="#contact">Connect</a>
                </li>
            </ul>
            <div className="footer__socials">
                <a href="https://www.linkedin.com/in/harshitbhandari01/">
                    <BsLinkedin />
                </a>
                <a href="https://www.instagram.com/harshitb2006/">
                    <FiInstagram />
                </a>
                <a href="https://github.com/harshitb01">
                    <FaGithub />
                </a>
            </div>
            <div className="footer__copyright">
                <small>&copy; Harshit Bhandari . All rights reserved.</small>
                <p>
                    Game Producer &amp; Technical Producer — leading people, product, and
                    technology from concept to launch. Currently producing
                    <a href="https://store.steampowered.com/" target="_blank" rel="noopener noreferrer"> Dread Manor &amp; Dread Protocol</a> for Steam.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
